import React, { useState, useEffect } from "react";
import Loader from "../../assets/C2C Loader.gif";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { ClickAwayListener } from "@material-ui/core";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import "./styles.scss";
import CheckedIcon from "../../assets/checked.png";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

export default function SearchPatientComponent(props) {
  const {
    hasError,
    removePatientName,
    setRemovePatientName,
    handleDisablePatientName,
    setPatientAccountId,
    countryCode,
    appointmentType,
    isCloseIconVisible = false,
  } = props;
  const [doctorList, setDoctorList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const debouncedSearchTerm = useDebounce(inputValue, 500);
  const [selected, setSelected] = useState(false);
  const [showLoaderImage, setShowLoaderImage] = useState(false);
  const [selectedInputValue, setSelectedInputValue] = useState("");

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(
    () => {
      if (!props.newPatient) {
        if (debouncedSearchTerm.length > 2) {
          if (props?.name !== "patient_name") {
            handleDisablePatientName();
          }
          let search = {};
          if (props?.name === "patient_name") {
            search = {
              patient_name: debouncedSearchTerm,
            };
          } else if (props?.name === "formatted_uhid") {
            let digits = debouncedSearchTerm.match(/\d+/g);
            search = {
              formatted_uhid: debouncedSearchTerm,
              uhid_number: digits?.length > 0 ? Number(digits[0]) : "",
            };
          } else {
            search = {
              phone_no: "+91" + debouncedSearchTerm,
            };
          }

          setShowLoaderImage(true);
          const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
          let payload = {
            doctor_id: props?.doctor_id ? props?.doctor_id : userId,
            search: search,
          };
          if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
            payload["clinic_id"] = clinicId;
          }
          afterLoginApiAxios({
            method: "post",
            url:
              clinicId !== "" && clinicId !== undefined && clinicId !== null
                ? "/clinic/get-own-patient "
                : "doctor/get-own-patient",

            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("id_token"),
            },
            data: payload,
          }).then((res) => {
            if (res.data.statusCode === 200) {
              setDoctorList(res.data.patient_list);
              props.getList(res.data.patient_list, false, props?.name);

              setShowLoaderImage(false);
            } else {
              setShowLoaderImage(false);
              props.getList([], false, props?.name);

              setDoctorList([]);
            }
          });
        } else {
          setShowLoaderImage(false);
          if (props.name === "patient_name") {
            if (!removePatientName) {
              props.getList([], false, props?.name);
              setDoctorList([]);
            }
          } else {
            props.getList([], false, props?.name);
            setDoctorList([]);
          }
          setRemovePatientName && setRemovePatientName(false);
        }
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  // Api Calls ===>

  const getPatients = (val) => {
    let search = {
      phone_no: "+91" + val,
    };

    const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    let payload = {
      doctor_id: props?.doctor_id ? props?.doctor_id : userId,
      search: search,
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      payload["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "/clinic/get-own-patient"
          : "doctor/get-own-patient",

      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    }).then((res) => {
      if (res.data.statusCode === 200) {
        setDoctorList(res.data.patient_list);
        props.getList(res.data.patient_list, true, props?.name);
        setShowLoaderImage(false);
      } else {
        setShowLoaderImage(false);
        props.getList([], true, props?.name);
        setDoctorList([]);
      }
    });
  };

  // <===

  const handleListClick = (selected) => {
    setPatientAccountId(selected.patient_account_id);
    setSelected(true);
    props.searchedPatientCallback(selected);
    setSelectedInputValue(
      props.inputType === "text"
        ? selected.patient_name
        : selected.patient_no.split("+91")[1]
    );
    getPatients(selected.patient_no.split("+91")[1]);
  };

  const closeData = () => {
    setDoctorList([]);
    setInputValue("");
    setPatientAccountId(null);
    if (props.name === "patient_name") {
      setRemovePatientName(true);
    } else {
      setRemovePatientName(false);
    }
    props.closeData();
  };

  const showLoader = () => {
    return (
      <div style={{ alignItems: "center", height: "80px" }}>
        <img
          src={Loader}
          alt="loader"
          style={{ alignItems: "center", width: "96%", height: "80px" }}
        />
      </div>
    );
  };

  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          setSelected(true);
        }}
      >
        <div
          className={`pc-search-wrapper ${
            doctorList && inputValue.length > 2 && !selected ? "isActive" : ""
          } `}
          style={{ width: "100%", maxHeight: "41px" }} //200px
        >
          <div
            className={`input-holder ${
              hasError && selected ? " search-error" : ""
            }`}
          >
            {countryCode && (
              <span className="patient-country-code-wrapper">+91</span>
            )}
            <input
              type={props.inputType}
              className="search-input"
              onKeyDown={(e) =>
                (e.keyCode === 69 ||
                  e.keyCode === 187 ||
                  e.keyCode === 61 ||
                  e.keyCode === 189) &&
                props.inputType === "number" &&
                e.preventDefault()
              }
              onChange={(e) => {
                setSelected(false);
                setInputValue(e.target.value);
                props.handleInputChange(e);
              }}
              onInput={props.maxLengthCheck}
              placeholder={props.placeholderText}
              defaultValue={selected ? selectedInputValue : inputValue} //inputValue && inputValue
              value={props.values} // props.values && props.values
              maxLength={props?.maxLengthValue}
              name={props?.name}
              disabled={props.disable}
              ref={props.inputRef}
              // ref={props.mergeRefs(
              //   props.inputRef,
              //   props.register({
              //     required: props.required,
              //   })
              // )}
            />
            {props?.values?.length > 2 || inputValue.length > 2 ? (
              <div
                className={`close_serch ${
                  isCloseIconVisible ? "mobile_close_serch" : ""
                }`}
                onClick={closeData}
              >
                <i class="fa fa-times-circle"></i>
              </div>
            ) : null}
          </div>
          <div className="searched_value" style={{ position: "absolute" }}>
            {doctorList && doctorList.length > 0 && !selected ? (
              <ul className="searched_value_scroll">
                {doctorList &&
                  doctorList.map((item) => (
                    <li onClick={() => handleListClick(item)}>
                      <div className="searched_item">
                        {props.showName ? (
                          <div className="searched_item_text">
                            <h5>{item.patient_name}</h5>
                          </div>
                        ) : (
                          <div className="searched_item_text">
                            <h5>{item.patient_name}</h5>
                            <p className="text-left">
                              {item.patient_no},{item?.patient_email}
                            </p>
                          </div>
                        )}

                        {item?.abha_address_kyc_verified?.toLowerCase() ===
                          "true" &&
                          appointmentType === "in-clinic" && (
                            <div className="abha-status-container">
                              <div className="abha-status-icon">
                                <img src={CheckedIcon} alt="" />
                              </div>
                              <div className="abha-status-text">
                                ABHA verified
                              </div>
                            </div>
                          )}
                      </div>
                    </li>
                  ))}
              </ul>
            ) : showLoaderImage ? (
              showLoader()
            ) : (
              <div className="no_data_found">No data found</div>
            )}
          </div>
        </div>
      </ClickAwayListener>
    </>
  );
}
